<template>
  <div>
    <section id="testimonial" class="testimonial-section padding-top-bottom-90 gradient-violat">
      <div class="container">
        <div class="heading-wraper text-center">
          <h4 class="text-white">{{aboutData.title}}</h4>
          <hr class="heading-devider gradient-orange">
        </div>
        <div class="row">
          <div class="col-md-8 col-md-offset-2">
            <div id="testimonial-carousel" class="owl-carousel">
              <div>
                <div class="testimonial-container">
                  <div class="client-details text-center">
                    <img src="images/j.png" alt="" width="100">
                    <h3 class="client-name">{{aboutData.part_one_title}}</h3>
                  </div>
                  <div class="testimonial-content pre-scrollable" data-height="300px" v-html="aboutData.part_one_content">
                    
                  </div>
                </div>
              </div>
              <div>
                <div class="testimonial-container">
                  <div class="client-details text-center">
                    <img src="images/j1.png" alt="" width="100">
                    <h5 class="client-name">{{aboutData.part_two_title}}</h5>
                  </div>
                  <div class="testimonial-content pre-scrollable"  data-height="300px"  v-html="aboutData.part_two_content">
                    </div>
                </div>
              </div>
              <div>
                <div class="testimonial-container">
                  <div class="client-details text-center">
                    <img src="images/j2.png" alt="" width="100">
                    <h5 class="client-name">{{aboutData.part_three_title}}</h5>
                    
                  </div>
                  <div class="testimonial-content pre-scrollable" data-height="300px" v-html="aboutData.part_three_content">
                    </div>
                </div>
              </div>
            </div>              
          </div>
        </div>
      </div>
    </section>
    <section id="customer-support" class="overflow-x-hidden">
        <div class="heading-wraper text-center">
          <h4 class="">{{recruitData.title}}</h4>
          <hr class="heading-devider gradient-orange">
        </div>
      <div class="row">
        <div class="col-md-6">
          <div class="customer-support-content  sm-padding-top-bottom-50-75"  data-height="390px"  v-html="recruitData.content_one">
            
            </div>
        </div>
        <div class="col-md-6">
          <div class="customer-support-content  sm-padding-top-bottom-50-75"  data-height="390px"  v-html="recruitData.content_two">
            
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'about',
  props:['aboutData','recruitData']
}

</script>



// WEBPACK FOOTER //
// src/components/about.vue